import React from 'react';
import { Theme } from '@indigo-ag/component-module';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

import { createStylesHook } from 'shared/hooks/createStylesHook';

interface IconWithBadgeProps {
  icon: IconProp;
  badge: string;
}

const useStyles = createStylesHook((theme: Theme) => ({
  iconWithBadge: {
    position: 'relative',
    marginRight: 2
  },
  badge: {
    fontSize: '0.75rem',
    fontWeight: 700,
    backgroundColor: 'rgb(240, 84, 66)',
    color: 'rgb(255, 255, 255)',
    minHeight: '1rem',
    minWidth: '1rem',
    borderRadius: 6,
    textAlign: 'center',
    padding: '2px 5px',
    position: 'absolute',
    left: '50%',
    bottom: '50%',
    margin: 0
  },
  icon: {
    overflow: 'visible',
    width: '1em',
    verticalAlign: '-0.225em',
    color: 'rgb(0, 87, 125)',
    fontSize: 18
  }
}));

export const IconWithBadge: React.FunctionComponent<IconWithBadgeProps> = ({ icon, badge }) => {
  /**
   * Styles
   */
  const classes = useStyles({});

  return (
    <div className={classes.iconWithBadge}>
      <FontAwesomeIcon icon={icon} className={classes.icon}></FontAwesomeIcon>
      <div className={classes.badge}>{badge}</div>
    </div>
  );
};
